module.exports = __webpack_public_path__ + "static/IBMPlexSerif-Light-fabde431316f09ed8c275e20e817fbef.ttf";